import { useNavigate } from "react-router-dom";

const AdminPanel = () => {
  const navigate = useNavigate();

  const onIdentificationClick = () => {
    navigate("/inn-check");
  };
  return (
    <div>
      <button onClick={onIdentificationClick}>Идентификация</button>
    </div>
  );
};

export default AdminPanel;
